import { SchoolUser } from "./account.domain";

export interface SchoolGroup {
    id: string;
    schoolAccountId: string;
    identifierCode: string;
    wondeId: string;
    misId: string;
    type: string;
    code: string;
    subject: string;
    alternative: boolean;
    priority: boolean;
    academicYear: string;
    yearGroup: string;
    name: string;
    description: string;
    status: SchoolGroupStatus; 
    /** Who owns the group (DIGI-1851); absent on groups the backend has not stamped yet. */
    source?: SchoolGroupSource;
    /** True on a year group the MIS sync adopted from a group the school made. */
    adoptedFromCustom?: boolean;
    members?: SchoolUser[];
    creationDatetime: Date; 
    lastModifiedDatetime: Date; 
}

/** Owner of a school group: made by the school, a year group from the MIS sync, or an MIS class. */
export type SchoolGroupSource = 'CUSTOM' | 'MIS_YEAR' | 'MIS_CLASS';

export enum SchoolGroupStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE"
}
/** A pupil a group removal would leave in no active group (DIGI-1701). */
export interface StrandedPupil {
  accountId: string;
  firstName?: string;
  lastName?: string;
}

/** remove-group refusal code: the removal would leave the pupils in the body in no active group. */
export const GROUP_STRANDS_PUPILS = 'GROUP_STRANDS_PUPILS';

/** Thrown by GroupService.deleteGroup when the backend refuses with {@link GROUP_STRANDS_PUPILS}. */
export class GroupStrandsPupilsError extends Error {
  constructor(readonly groupId: string, readonly pupils: StrandedPupil[]) {
    super(GROUP_STRANDS_PUPILS);
    this.name = 'GroupStrandsPupilsError';
  }
}
